export default {
  paper: {
    width: 'auto !important',
    maxWidth: '30vw !important',
  },
}
